import {
  allTableColumn,
  conversionFields,
  DateTimeType,
  entryType,
  equipmentStatus,
  listOfSetFieldSearchManipulationQuery,
  MY_LAB,
  SNACKBAR_DURATION,
} from "../Constants/constants";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import {
  convertToCameCase,
  convertToSnakeCase,
  exactSearchString,
  replaceDateUtil
} from "./equipmentService";
import EQUIPMENT_DATA_MODEL_TABLE from "../Constants/DataModelTable";
import { find } from "lodash-es";

export const checkNullInArrayOfStr = (list = []) => {
  if (!list || list?.length === 0) return false;
  let isNull = false;
  let index = 0;
  do {
    if (list && !list[index]) {
      isNull = true;
      break;
    }
    index++;
  } while (index < list.length);

  return isNull;
};



const getCoversionField = (metric, field) => {
  let fieldValue = field;
  if (metric !== "metric" && conversionFields?.includes(convertToCameCase(field))) {
    let obj = find(allTableColumn(), { key: convertToCameCase(field) });
    fieldValue = convertToSnakeCase(obj?.imperialField);
  }

  return fieldValue;
};

export const getNumberSearchQuery = ({
  fields,
  searchValue,
  operator,
  metric,
  listOfFieldAcceptOnlyInteger = [],
}) => {
  let searchNumberString = [];
  fields?.forEach((field) => {
    let key = getCoversionField(metric, field);
    let searchText = searchValue;
    if (
      (listOfFieldAcceptOnlyInteger?.includes(convertToCameCase(field)) &&
        conversionFields?.includes(convertToCameCase(field)) &&
        metric === "metric") ||
      (listOfFieldAcceptOnlyInteger?.includes(convertToCameCase(field)) &&
        !conversionFields?.includes(convertToCameCase(field)))
    ) {
      searchText = parseInt(searchValue);
    }
    searchNumberString.push(`(${key}:${searchText})`);
  });

  return searchNumberString?.join(` ${operator} `);
};

export const replaceSpecialCharWithSpace = (value) => {  // eslint-disable-next-line no-useless-escape
  return value.replace(/[!@#$%^&*()+=\[\]{};:\\|,<>?~\-"\/]/g, " ");
};

/**
 * changing ag grid filters to CloudSearch query text
 */
export const getFilterModelQuery = ({
  filterModel,
  type,
  filterName = "",
  masterDatas = {},
  metric = "metric",
  literalFields = [],
}) => {
  let filterTextQuerys = [];

  for (let key in filterModel) {
    let query = ``;
    let queries = [];
    // let conditions = [];
    if (type === "set") {
      const removeIndex = filterModel[key]?.values.findIndex((item) => !item);
      let blank = null;
      if (masterDatas[convertToCameCase(key)]?.length === filterModel[key]?.values?.length) {
        query = `(${key}:*`;
        if (removeIndex !== -1) {
          query = `${query} OR (*:* OR -${key}:*)`;
        }
        query = `${query})`;
      } else {
        if (removeIndex !== -1) {
          blank = filterModel[key]?.values?.splice(removeIndex, 1);
        }
        if (filterModel[key]?.values?.length !== 0) {
          let updatedArray = [];
          updatedArray = exactSearchString(filterModel[key]?.values)?.map(
            (value) => `${key}:${key === "_id" ? `${value}` : `"${replaceSpecialCharWithSpace(value).trim()}"`}`
          );
          if (listOfSetFieldSearchManipulationQuery?.includes(convertToCameCase(key))) {
            query = `${updatedArray?.join(" OR ")}`;
            if (!filterModel[key]?.values?.includes("Not calibrated")) {
              query = `${query} NOT (display_qualification_status:'Not calibrated')`;
            }
            if (!filterModel[key]?.values?.includes("Not qualified")) {
              query = `${query} NOT (display_qualification_status:'Not qualified')`;
            }
            query = `(${query})`;
          } else {
            query = `(${updatedArray?.join(" OR ")})`;
          }
        }
        if (blank) {
          query = query ? `(${query} OR (*:* OR -${key}:*))` : `(*:* OR -${key}:*)`;
        }
      }
    } else if (filterModel[key]?.operator) {
      let testConditions = [];
      let conditions = [];
      if (filterModel[key]?.conditions) {
        conditions = [...filterModel[key]?.conditions];
      } else {
        conditions = [filterModel[key]?.condition1, filterModel[key]?.condition2];
      }
      testConditions = [...conditions];
      const keyValue = getCoversionField(metric, key);
      // FIX:  Can we use switch case and enum here
      testConditions?.forEach((condition) => {
        if (condition?.type === "equals") {
          queries?.push(`${keyValue}:${condition?.filter}`);
        } else if (condition?.type === "contains") {
          let textValue = replaceSpecialCharWithSpace(condition?.filter);

          queries?.push(`${keyValue}:*${textValue}*`);
        } else if (condition?.type === "notContains") {
          queries?.push(`-${keyValue}:*${condition?.filter}*`);
        } else if (condition?.type === "notEqual") {
          queries?.push(`-${keyValue}:${condition?.filter}`);
        } else if (condition?.type === "lessThan" || condition?.type === "lessThanOrEqual") {
          queries?.push(`${keyValue}:[* TO ${condition?.filter}}`);
        } else if (condition?.type === "greaterThan" || condition?.type === "greaterThanOrEqual") {
          queries?.push(`${keyValue}:{${condition?.filter} TO *]`);
        } else if (condition?.type === "notBlank") {
          queries?.push(type === "text" ? `(*:* OR ${keyValue}:*)` : `${keyValue}:[* TO *]`);
        } else {
          queries?.push(type === "text" ? `(*:* OR -${keyValue}:*)` : `-${keyValue}:[* TO *]`);
        }
      });
      query = `(${queries?.join(` ${filterModel[key]?.operator} `)})`;
    } else {
      const keyValue = getCoversionField(metric, key);
      if (filterModel[key]?.type === "equals") {
        if (type === "date") {
          query = `${
            keyValue
          }:[${
            replaceDateUtil(filterModel[key]?.dateFrom, DateTimeType.start)
          } TO ${
            replaceDateUtil(filterModel[key]?.dateFrom, DateTimeType.end)
          }]`;
        } else {
          query = `${keyValue}:${filterModel[key]?.filter}`;
        }
      } else if (filterModel[key]?.type === "contains") {
        let textValue = replaceSpecialCharWithSpace(filterModel[key]?.filter);
        query = `${keyValue}:*${textValue}*`;
      } else if (filterModel[key]?.type === "notContains") {
        query = `-${keyValue}:*${filterModel[key]?.filter}*`;
      } else if (filterModel[key]?.type === "startsWith") {
        query = `${keyValue}:${filterModel[key]?.filter}*`;
      } else if (filterModel[key]?.type === "endsWith") {
        query = `${keyValue}:*${filterModel[key]?.filter}`;
      } else if (filterModel[key]?.type === "notEqual") {
        if (type === "date") {
          query = `-${
            keyValue
          }:[${
            replaceDateUtil(filterModel[key]?.dateFrom, DateTimeType.start)
          } TO ${
            replaceDateUtil(filterModel[key]?.dateFrom, DateTimeType.end)
          }]`;
        } else {
          query = -`${keyValue}:${filterModel[key]?.filter}`;
        }
      } else if (filterModel[key]?.type === "lessThan" || filterModel[key]?.type === "lessThanOrEqual") {
        if (type === "date") {
          query = `${
            keyValue
          }:[* TO ${
            replaceDateUtil(filterModel[key]?.dateFrom, DateTimeType.start)
          }]`;
        } else {
          query = `${keyValue}:[* TO ${filterModel[key]?.filter}]`;
        }
      } else if (filterModel[key]?.type === "greaterThan" || filterModel[key]?.type === "greaterThanOrEqual") {
        if (type === "date") {
          query = `${
            keyValue
          }:[${
            replaceDateUtil(filterModel[key]?.dateFrom, DateTimeType.start)
          } TO *]`;
        } else {
          query = `${keyValue}:[${filterModel[key]?.filter} TO *]`;
        }
      } else if (filterModel[key]?.type === "inRange") {
        if (type === "date") {
          query = `${
            keyValue
          }:[${
            replaceDateUtil(filterModel[key]?.dateFrom, DateTimeType.start)
          } TO ${
            replaceDateUtil(filterModel[key]?.dateTo, DateTimeType.end)
          }]`;
        } else {
          query = `${keyValue}:[${filterModel[key]?.filter} TO ${filterModel[key]?.filterTo}]`;
        }
      } else if (filterModel[key]?.type === "notBlank") {
        query = type === "text" ? `(*:* OR ${keyValue}:*)` : `${keyValue}:[* TO *]`;
      } else {
        query = type === "text" ? `(*:* OR -${keyValue}:*)` : `-${keyValue}:[* TO *]`;
      }
    }
    filterTextQuerys?.push(query);
  }

  let finalStringSearchQuery =
    filterTextQuerys?.length > 1 ? filterTextQuerys?.join(" AND ") : filterTextQuerys[0] || "";

  if (filterName === MY_LAB) {
    finalStringSearchQuery += ` AND (status:'${equipmentStatus?.active?.value}') AND (entry_type:'${entryType?.cluster}' OR entry_type:'${entryType?.standaloneEquipment}') NOT (entry_type:'${entryType?.clusterSubequipment}')`;
  }

  if (literalFields?.length > 0) {
    literalFields?.forEach((literalFieldObj) => {
      let str = convertToSnakeCase(literalFieldObj?.key);
      if (finalStringSearchQuery?.includes(str)) {
        finalStringSearchQuery = finalStringSearchQuery?.replaceAll(str, literalFieldObj?.value);
      }
    });
  }
  return finalStringSearchQuery;
};

const EXCLUDED_FILTER_KEYS = new Set(["dateFrom", "dateTo", "inventoryIds", "isHazardous", "shouldAssisted"]);

const mapFilterValue = (key, value, filterKeyMapping) => {
  if (!value) {
    return null;
  }

  const mappedKey = filterKeyMapping[key] || key;
  
  if (Array.isArray(value)) {
    return {
      [mappedKey]: {
        values: value,
        filterType: "set",
      },
    };
  }

  // Older saved filters store Nickname as a bare string from when it was a text filter. It is a
  // set filter now and AG Grid ignores anything else on it, so promote it, as
  // buildAgGridFilterModel in useInstrumentCache does. Blank values were a no-op before and stay one.
  // Trimmed because the text filter trimmed it too, and a set filter matches exactly.
  if (typeof value === "string" && key === EQUIPMENT_DATA_MODEL_TABLE.equipmentNickName?.key) {
    const nickname = value.trim();
    return nickname === "" ? null : { [mappedKey]: { values: [nickname], filterType: "set" } };
  }

  return {
    [mappedKey]: value,
  };
};

const buildFilterObject = (savedFilterModel, filterKeyMapping) => {
  const obj = {};
  
  for (const key in savedFilterModel) {
    if (EXCLUDED_FILTER_KEYS.has(key)) {
      continue;
    }

    const mapped = mapFilterValue(key, savedFilterModel[key], filterKeyMapping);
    if (mapped) {
      Object.assign(obj, mapped);
    }

    // Special case for equipment model
    if (key === EQUIPMENT_DATA_MODEL_TABLE.equipmentModel?.key && Array.isArray(savedFilterModel[key])) {
      obj["ag-Grid-AutoColumn"] = {
        values: savedFilterModel[key],
        filterType: "set",
      };
    }
  }

  return obj;
};

// Keep only filters for columns that actually exist in the current grid instance.
// This avoids AG Grid runtime errors when stale/derived colIds are present.
export const sanitizeFilterModelForGrid = (gridApi, filterModel) => {
  if (!gridApi || !filterModel) {
    return filterModel;
  }

  try {
    const validColIds = new Set(
      (gridApi.getColumns?.() || [])
        .map((col) => col?.getColId?.())
        .filter(Boolean)
    );

    // If grid columns are not yet available, keep the original model.
    if (validColIds.size === 0) {
      return filterModel;
    }

    return Object.entries(filterModel).reduce((acc, [colId, value]) => {
      if (validColIds.has(colId)) {
        acc[colId] = value;
      }
      return acc;
    }, {});
  } catch (error) {
    return filterModel;
  }
};


export const onAgGridFilterApply = ({ gridRef, savedFilterModel, filterKeyMapping }) => {
  if (!gridRef?.current?.api) {
    return undefined;
  }

  const filterObj = buildFilterObject(savedFilterModel, filterKeyMapping);
  const safeFilterObj = sanitizeFilterModelForGrid(gridRef.current.api, filterObj);
  gridRef.current.api.setFilterModel(safeFilterObj);

  let currentSidePannel = null;
  try {
    currentSidePannel = gridRef.current.api.getOpenedToolPanel();
  } catch (_error) {
    currentSidePannel = null;
  }
  return { currentSidePannel };
};

export const onUpdateFilter = async ({
  lastFavFilter,
  isSaveClicked,
  updateRedux = true,
  id,
  email,
  client,
  query,
  userProfileQuery,
  updateLastFavFilter = null,
}) => {
  let lastFilterData = {};
  lastFilterData.lastFavFilter = lastFavFilter;
  lastFilterData = JSON.stringify(lastFilterData);
  let result;
  try {
    result = await client.mutate({
      mutation: userProfileQuery,
      variables: { id, email, lastFilter: lastFilterData },
    });

    if (isSaveClicked) {
      const filterDefinition =
        typeof lastFavFilter?.filterDefinition === "string"
          ? lastFavFilter?.filterDefinition
          : JSON.stringify(lastFavFilter?.filterDefinition);
      await client.mutate({
        mutation: query,
        variables: {
          userID: id,
          filterName: lastFavFilter?.filterName,
          filterDefinition,
        },
        fetchPolicy: "no-cache",
      });
    }

    if (isSaveClicked) {
      snackbarService.show({
        message: "Updated filter successfully",
        type: "success",
        duration: SNACKBAR_DURATION,
      });
    }
  } catch (error) { console.log(error)
    console.error(error)
    if (isSaveClicked) {
      snackbarService.show({
        message: "Failed to update filter",
        type: "warning",
        duration: SNACKBAR_DURATION,
      });
    }
    result = null;
  }
  if (updateRedux && updateLastFavFilter) {
    updateLastFavFilter(lastFavFilter);
  }
  return result;
};

export const onCreatefilter = async ({
  id,
  userFilters,
  lastFavFilter,
  client,
  query,
  updateUserFilters = null,
}) => {
  let result = null;
  try {
    const FilterNameMatch = userFilters.filter((item) => item.filterName === lastFavFilter?.filterName?.trim());
    if (FilterNameMatch.length === 0 && lastFavFilter?.filterName !== MY_LAB) {
      result = await client.mutate({
        mutation: query,
        variables: {
          userID: id,
          filterDefinition: JSON.stringify(lastFavFilter?.filterDefinition),
          filterName: lastFavFilter.filterName?.trim(),
        },
      });
      if (result) {
        await onUpdateFilter(lastFavFilter);
        if (updateUserFilters) {
          updateUserFilters([...userFilters, lastFavFilter]);
        }
      }
      snackbarService.show({
        message: "Filters successfully saved",
        type: "success",
        duration: SNACKBAR_DURATION,
      });
    } else {
      snackbarService.show({
        message: "Duplicate filter name",
        type: "warning",
        duration: SNACKBAR_DURATION,
      });
    }
  } catch (err) {
    console.log(err);
    snackbarService.show({
      message: "Filter creation failure",
      type: "error",
      duration: SNACKBAR_DURATION,
    });
  }

  return result;
};

export const isNumber = (value) => {
  const conv = +value;
  return !!conv;
};
